<form class="cart-item-form" (submit)="submitForm($event)" novalidate>
  <h2 class="cart-item-form__title">Edit Time Frame</h2>
  <p class="cart-item-form__subtitle">
    @if (isOngoingSession()) {
      Choose “Ongoing” to make the end match the live/current time, or “Custom end time” to set a different end time.
    } @else {
      Start and end times can be edited within the period of <strong>{{ formattedSessionTimes() }}</strong
      >.
    }
    Multiple time frames can be added if necessary.
  </p>
  @if (isOngoingSession()) {
    <div class="cart-item-form__ongoing-end-radios">
      <ftr-radio-list [control]="ongoingEndControl" [items]="ongoingEndRadios" [radioListStyle]="radioListStyle" />
    </div>
  }
  <div class="cart-item-form__timeframes">
    @for (control of formArray.controls; track control) {
      <div class="cart-item-form__timeframe">
        <div class="cart-item-form__timeframe-controls">
          @if ($last && lastTimeframeIsOngoing()) {
            <div class="cart-item-form__ongoing-control">
              <div>
                <ftr-time-input
                  [control]="control.controls.start"
                  label="From"
                  [timeFormat]="timeFormat"
                  [showIcon]="false"
                  [isLarge]="true"
                />
              </div>
              <div>
                <div class="cart-item-form__ongoing-label">To</div>
                <div>Ongoing</div>
              </div>
            </div>
            <span
              ftrValidationErrorHint
              class="input__validation"
              [ngFormControl]="control"
              [controlTouched]="control.touched"
              label="Ongoing"
            ></span>
          } @else {
            <ftr-time-range
              [control]="control"
              [precision]="precision"
              startLabel="From"
              endLabel="To"
              [showIcons]="false"
              [isLarge]="true"
            />
          }
        </div>
        @if (formArray.length > 1) {
          <button ftrIconButton icon="Close" size="small" type="button" (click)="removeTimeframe($index)">
            Remove
          </button>
        }
      </div>
    }
    <span
      ftrValidationErrorHint
      class="input__validation"
      [ngFormControl]="formArray"
      [controlTouched]="formArray.touched"
      label="Time Range"
    ></span>
  </div>
  <div class="cart-item-form__footer">
    <div class="cart-item-form__footer-left">
      <button ftrButton color="primary" type="submit">Save</button>
      <button ftrButton color="secondary" type="button" (click)="cancelClicked.emit()">Cancel</button>
    </div>
    <div class="cart-item-form__footer-right">
      <button
        ftrButton
        class="cart-item-form__add-timeframe-button"
        color="secondary"
        type="button"
        [flexLayout]="true"
        (click)="addTimeframe()"
      >
        <ftr-icon-legacy icon="Add" size="Large" />
        ADD TIME FRAME
      </button>
    </div>
  </div>
</form>
